module.exports = __webpack_public_path__ + "static/media/logo-dark.bd1ed969.jpg";